"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addModal = exports.omitAnchorListernerOneTime = exports.initAnchorModalListener = void 0;
const effects_1 = require("redux-saga/effects");
const reducers_modals_reducer_1 = require("@/bit/reducers/reducers.modals-reducer");
let history = null;
let anchorModule = null;
let addModalModule = null;
let startedModalListener = false;
function* initAnchorModalListener() {
    if (!anchorModule) {
        anchorModule = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./anchor-modal-listener-module'))));
    }
    yield (0, effects_1.call)(anchorModule.initAnchorModalListenerModule, { end: false, history });
}
exports.initAnchorModalListener = initAnchorModalListener;
function* omitAnchorListernerOneTime(flag) {
    if (!anchorModule) {
        anchorModule = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./anchor-modal-listener-module'))));
    }
    yield (0, effects_1.call)(anchorModule.setOmitAnchorListernerOneTime, flag);
}
exports.omitAnchorListernerOneTime = omitAnchorListernerOneTime;
let localModal = null;
function* addModal({ data }) {
    if (!history) {
        history = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('history'))));
        history = history.createBrowserHistory();
        if (!startedModalListener) {
            startedModalListener = true;
            yield (0, effects_1.put)(reducers_modals_reducer_1.actions.initAnchorModalListener());
        }
    }
    if (data && (data.omitAnchorListener)) {
        yield (0, effects_1.call)(omitAnchorListernerOneTime, true);
    }
    else {
        yield (0, effects_1.call)(omitAnchorListernerOneTime, false);
    }
    // hacemos el import 
    if (!addModalModule) {
        addModalModule = yield (0, effects_1.call)(() => Promise.resolve().then(() => __importStar(require('./add-modal'))));
    }
    let retries = 5;
    let Modal = yield (0, effects_1.select)((state) => state.modals.Modal);
    while (!Modal && retries > 0) {
        retries = retries - 1;
        yield delay(100);
        Modal = yield (0, effects_1.select)((state) => state.modals.Modal);
    }
    yield (0, effects_1.call)(addModalModule.default, Object.assign(Object.assign({}, data), { history }));
}
exports.addModal = addModal;
//# sourceMappingURL=index.js.map